export function toggleOneTrust() {
    try {
        // @ts-expect-error OneTrust is implemented dynamically
        OneTrust.ToggleInfoDisplay();
    } catch (error) {
        console.error('Cannot find OneTrust');
    }
}
